import styled from 'styled-components';
import ds from 'designsystem';

const RequiredIndicator = styled.span`
  &:after {
    display: inline-block;
    margin-left: 3px;
    color: ${ds.brand('product')};
    content: '*';
  }
   
`;

export default RequiredIndicator;



// WEBPACK FOOTER //
// ./src/blocks/Form/RequiredIndicator.jsx